import { getImageUrl } from '.';

export const IMAGES = {
    fairway: getImageUrl('marketing/fairway.jpeg'),
    caddy_reading_green: getImageUrl('marketing/caddy-reading-green.jpeg'),
    caddy_walking: getImageUrl('marketing/caddy-walking.jpeg'),
    cade_cart: getImageUrl('marketing/cade_cart.jpeg'),
    cade_swing: getImageUrl('marketing/cade-swing.jpeg'),
    scorecard: getImageUrl('marketing/scorecard.jpeg'),
    scorecard_cart: getImageUrl('marketing/scorecard-cart.jpeg'),
    example_green: getImageUrl('dispersion/example_green.png'),
};
